import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
export var useProfileStore = defineStore({
  id: 'profile',
  state: function state() {
    return {
      closing: false,
      opening: false,
      modelName: null,
      modelId: null,
      anchorId: null,
      placement: null,
      ddName: 'profile-informer',
      profile: null,
      activeSubMenu: [{
        menu: 'courses',
        submenu: "design"
      }]
    };
  },
  actions: {
    open: function open(_ref) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, value;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              id = _ref.id, value = _ref.value;
              _this.opening = true;
              _this.anchorId = id;
              if (value && value.placement) _this.placement = value.placement;
              if (value && value.fallbackPlacements) _this.fallbackPlacements = value.fallbackPlacements;
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(!_this.opening || id != _this.anchorId)) {
                        _context.next = 2;
                        break;
                      }
                      return _context.abrupt("return");
                    case 2:
                      if (!(value.modelName != _this.modelName || value.modelId != _this.modelId)) {
                        _context.next = 11;
                        break;
                      }
                      _context.next = 5;
                      return _this.$nuxt.$axios.$get("/".concat(value.modelName, "/businesscard/").concat(value.modelId), {
                        progress: false
                      }).catch(function (err) {
                        console.log(err);
                      });
                    case 5:
                      res = _context.sent;
                      if (!(!res || !res.author)) {
                        _context.next = 8;
                        break;
                      }
                      return _context.abrupt("return");
                    case 8:
                      _this.modelId = value.modelId;
                      _this.modelName = value.modelName;
                      _this.profile = res;
                    case 11:
                      _this.setClosing = false;
                      _this.$nuxt.$modalityStore.openDropdown({
                        name: _this.ddName,
                        id: id
                      });
                      _this.$nuxt.$gtag('event', 'profile_card', {
                        type: value.modelName
                      });
                    case 14:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })), 700);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // TODO is it really have to be here?
    continue: function _continue() {
      this.closing = false;
    },
    close: function close() {
      var _this2 = this;
      this.closing = true;
      this.opening = false;
      setTimeout(function () {
        if (_this2.closing) {
          _this2.$nuxt.$modalityStore.closeDropdown({
            name: _this2.ddName
          });
        }
      }, 300);
    }
  }
});